import React, { useState } from 'react';
import ExamPortal from './ExamPortal';
import DeviceCheck from './DeviceCheck';

const StudentView = () => {
  const [started, setStarted] = useState(false);
  const [studentName, setStudentName] = useState('');
  const [blocked, setBlocked] = useState(false);
  const [deviceCheckDone, setDeviceCheckDone] = useState(false);
  const [preExamSessionId, setPreExamSessionId] = useState(null);

  if (blocked) {
    return (
      <div style={styles.blocked}>
        <div style={styles.blockedCard}>
          <div style={styles.blockedIcon}>⛔</div>
          <h1 style={{ margin: '0 0 8px', fontSize: 28, fontWeight: 800, color: '#c62828' }}>Access Denied</h1>
          <p style={{ margin: 0, color: '#888', fontSize: 16 }}>
            You have already taken this exam, or the link is invalid.
          </p>
          <button onClick={() => window.location.href = '/'}
            style={styles.homeBtn}
            onMouseEnter={e => e.currentTarget.style.background = '#1b5e20'}
            onMouseLeave={e => e.currentTarget.style.background = '#2e7d32'}
          >Go Home</button>
        </div>
      </div>
    );
  }

  if (!started) {
    return (
      <div style={styles.wrapper}>
        <div style={styles.startCard}>
          <div style={styles.shieldIcon}>🛡️</div>
          <h1 style={styles.startTitle}>Online Proctored Exam</h1>
          <p style={styles.startDesc}>
            You are about to begin a proctored examination. Your webcam and microphone will be recorded throughout the session.
          </p>

          <div style={styles.requirements}>
            <div style={styles.reqItem}>📷 Webcam access required</div>
            <div style={styles.reqItem}>🎙️ Microphone access required</div>
            <div style={styles.reqItem}>🔒 Full-screen mode enforced</div>
            <div style={styles.reqItem}>⚠️ Leaving the exam window will be flagged</div>
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.inputLabel}>Enter your Full Name (as registered)</label>
            <input type="text" placeholder="e.g. John Doe" value={studentName}
              onChange={e => setStudentName(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && studentName.trim() && setStarted(true)}
              style={styles.nameInput} />
          </div>

          <button onClick={() => {
            if (!studentName.trim()) return alert('Please enter your name!');
            setStarted(true);
          }} style={styles.startBtn}
            onMouseEnter={e => { if (studentName.trim()) e.currentTarget.style.transform = 'scale(1.03)'; }}
            onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
          >Continue →</button>
        </div>
      </div>
    );
  }

  if (!deviceCheckDone) {
    return <DeviceCheck onProceed={(sid) => { setPreExamSessionId(sid); setDeviceCheckDone(true); }} />;
  }

  return <ExamPortal studentName={studentName} preExamSessionId={preExamSessionId} />;
};

const styles = {
  wrapper: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(160deg, #0a0a0a 0%, #111827 50%, #0d1f12 100%)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    padding: 24
  },
  startCard: {
    background: '#fff', borderRadius: 20, padding: '48px 40px',
    maxWidth: 480, width: '100%', textAlign: 'center',
    boxShadow: '0 25px 80px rgba(0,0,0,.3)'
  },
  shieldIcon: { fontSize: 56, marginBottom: 16 },
  startTitle: {
    margin: '0 0 8px', fontSize: 28, fontWeight: 800, color: '#111'
  },
  startDesc: {
    margin: '0 0 24px', fontSize: 14, lineHeight: 1.7, color: '#666'
  },
  requirements: {
    background: '#f8fdf8', borderRadius: 12, padding: 16,
    marginBottom: 24, textAlign: 'left',
    display: 'flex', flexDirection: 'column', gap: 8
  },
  reqItem: {
    fontSize: 13, color: '#333', fontWeight: 500
  },
  inputGroup: {
    textAlign: 'left', marginBottom: 20
  },
  inputLabel: {
    display: 'block', fontWeight: 700, color: '#333',
    marginBottom: 8, fontSize: 14
  },
  nameInput: {
    width: '100%', padding: '12px 16px', borderRadius: 10,
    border: '1px solid #ddd', fontSize: 16, outline: 'none',
    boxSizing: 'border-box', transition: 'border-color .2s'
  },
  startBtn: {
    width: '100%', padding: '14px', borderRadius: 12, border: 'none',
    background: 'linear-gradient(135deg,#4cbb4c,#2e9e2e)',
    color: '#fff', fontWeight: 700, fontSize: 16, cursor: 'pointer',
    transition: 'all .25s'
  },
  blocked: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#f5f5f5', fontFamily: "'Segoe UI', sans-serif", padding: 24
  },
  blockedCard: {
    background: '#fff', borderRadius: 20, padding: '48px 40px',
    maxWidth: 420, width: '100%', textAlign: 'center',
    boxShadow: '0 10px 40px rgba(0,0,0,.1)'
  },
  blockedIcon: { fontSize: 56, marginBottom: 16 },
  homeBtn: {
    marginTop: 24, padding: '12px 32px', borderRadius: 10, border: 'none',
    background: '#2e7d32', color: '#fff', fontWeight: 700, fontSize: 15,
    cursor: 'pointer', transition: 'all .25s'
  }
};

export default StudentView;
